import { API } from '@/models/core'
import { CricketSeason } from './season'
import { CricketMatch } from './match'

export function homePage () {
  return API.instance().get('/cricket/').then((resp) => {
    const matchOrder = resp.data.data.recent_matches.intelligent_order
    const matchesRaw = resp.data.data.recent_matches.cards
    let matches = {}
    matchesRaw.forEach(raw => {
      const match = CricketMatch.createFromJson(raw)
      matches[match.key] = match
    })

    let recentMatches = []
    matchOrder.forEach(key => {
      if (matches[key]) {
        recentMatches.push(matches[key])
      }
    })

    let recentSeasons = []
    resp.data.data.recent_seasons.forEach(raw => {
      recentSeasons.push(CricketSeason.createFromJson(raw))
    })

    recentSeasons.sort((x, y) => {
      if (x.start_at < y.start_at) {
        return -1
      } else if (x.start_at > y.start_at) {
        return 1
      }
      return 0
    })

    const news = resp.data.data.news

    return { recentMatches, recentSeasons, news }
  })
}

export class MetricCricketCoverageSelected {
  constructor (board, childBoard, season, month) {
    this.board = board
    this.child_boards = childBoard
    this.season = season
    this.month = month
  }

  buildUrl (name, key) {
    let query = {}
    let params = {
      key,
      board: this.board,
      season: this.season
    }

    if (this.month) {
      query.month = this.month
    }

    return { name, params }
  }
}

export class CricketCoverageSelected {
  constructor (board, competition, year, vsTeam) {
    this.board = board
    this.competition = competition
    this.year = year
    this.vsTeam = vsTeam
  }

  buildUrl (name, key) {
    let query = {}
    let params = {
      key,
      board: this.board,
      competition: this.competition,
      year: this.year
    }

    if (this.vsTeam) {
      query.vsTeam = this.vsTeam
    }

    return { name, params, query }
  }
}


export class MetricCricketCoverage {

  static selectBoardKey (board, month) {
    MetricCricketCoverage.State.selected.board = board.key
    return API.instance().get(`/cricket/v4/board/${board.key}/schedule/?month=${month}`).then((resp) => {
      const boardSchedule = MetricCricketCoverage.createFromJson(resp.data.data.team.seasons)
      return boardSchedule
    })
  }

  static selectChildBoards (key) {
    MetricCricketCoverage.State.selected.childBoards = key
    return API.instance().get(`/cricket/v4/board/${key}/schedule/`).then((resp) => {
      const boardSchedule = MetricCricketCoverage.createFromJson(resp.data.data.team.seasons)
      return boardSchedule
    })
  }

  static selectMonth (month) {
    MetricCricketCoverage.State.selected.month = month
    return API.instance().get(`/cricket/v4/board/${MetricCricketCoverage.State.selected.board}/schedule/?month=${month}`).then((resp) => {
      const boardSchedule = MetricCricketCoverage.createFromJson(resp.data.data.team.seasons)
      return boardSchedule
    })
  }

  static selectSeason (seasonKey) {
    MetricCricketCoverage.State.selected.season = seasonKey
  }

  static fetchCoverage () {
    return API.instance().get('/cricket/v4/').then((resp) => {
      const coverage = MetricCricketCoverage.createFromJson(resp.data.data.coverage)
      return coverage
    })
  }

  static createFromJson (raw) {
    let coverage = new MetricCricketCoverage()
    coverage = Object.assign(coverage, raw)
    return coverage
  }
}

export class CricketCoverage {
  selectBoard (boardKey) {
    const competitionKey = Object.keys(this[boardKey].competitions)[0]
    const competition = this[boardKey].competitions[competitionKey]
    CricketCoverage.State.selected.board = boardKey
    CricketCoverage.State.selected.competition = competition.key
    CricketCoverage.State.selected.year = null
    this.resetVsTeamIfNeed()
  }

  selectCompetition (competitionKey) {
    CricketCoverage.State.selected.competition = competitionKey
    CricketCoverage.State.selected.year = null
    this.resetVsTeamIfNeed()
  }

  selectYear (year) {
    CricketCoverage.State.selected.year = year
    this.resetVsTeamIfNeed()
  }

  selectVsTeam (vsTeam) {
    if (!vsTeam) {
      CricketCoverage.State.selected.vsTeam = null
    } else {
      CricketCoverage.State.selected.vsTeam = vsTeam
    }
  }

  resetVsTeamIfNeed () {
    if (!CricketCoverage.State.selected.vsTeam) {
      CricketCoverage.State.selected.vsTeam = null
    }
  }

  static createFromJson (raw) {
    let coverage = new CricketCoverage()
    coverage = Object.assign(coverage, raw)
    return coverage
  }

  static fetch () {
    return API.instance().get('/cricket/coverage/').then((resp) => {
      const coverage = CricketCoverage.createFromJson(resp.data.data.coverage)
      return coverage
    })
  }
}

CricketCoverage.State = {
  coverage: null,
  selected: new CricketCoverageSelected('icc', 'international-one-day', null, null),
  fetch () {
    return CricketCoverage.fetch().then((coverage) => {
      CricketCoverage.State.coverage = coverage
      return coverage
    })
  }
}

MetricCricketCoverage.State = {
  coverage: null,
  selected: new MetricCricketCoverageSelected('icc', null, null, null),
  fetch (isMetric) {
    if (isMetric) {
      return MetricCricketCoverage.fetchCoverage().then((coverage) => {
        MetricCricketCoverage.State.coverage = coverage
        return coverage
      })
    }
  }
}